import React, { useEffect } from 'react';
import { Box, Typography, Container, Divider, useTheme } from '@mui/material';

export default function Terms() {
  const theme = useTheme();

  useEffect(() => {
    document.title = "Terms & Conditions | CoreTechTalks";
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      {/* Header */}
      <Box sx={{ mb: 6 }}>
        <Typography 
          variant="h2" 
          component="h1" 
          sx={{ fontWeight: 800, mb: 2, fontFamily: '"Outfit", sans-serif' }}
        >
          Terms & Conditions
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Effective Date: July 1, 2026
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            1. Agreement to Terms
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
            Welcome to CoreTechTalks. By accessing, reading, or browsing technical articles on CoreTechTalks.com, or by utilizing any of our client-side software utilities (including the Rent Agreement Red Flag Detector), you agree to be bound by these Terms & Conditions.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            If you do not agree to all of these terms, you are explicitly prohibited from using our site and must discontinue use immediately.
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            2. Intellectual Property Rights
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
            Unless otherwise indicated, CoreTechTalks and all technical articles, documentation, custom UI layouts, tool logic, graphics, source code, and logo elements are our proprietary intellectual property.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            You are granted a limited license to read our publications and use our utility tools for personal or commercial evaluation. No part of our publications or tools may be reproduced, sold, or modified without our prior written consent.
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            3. Disclaimer & Non-Legal Advice
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2, color: 'warning.main', fontWeight: 600 }}>
            IMPORTANT LEGAL DISCLAIMER:
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, pl: 3, borderLeft: `3px solid ${theme.palette.warning.main}`, mb: 2 }}>
            The Rent Agreement Red Flag Detector and any other audit/document inspection tools provided on CoreTechTalks are for general reference and informational purposes only. The outputs, audited checklists, and flagged points do not constitute formal legal advice or binding representation.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            Always consult a qualified legal professional regarding tenancy disputes, formal contract execution, or legal interpretations. We assume no liability for decisions made or contracts signed based on outputs generated by our software.
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            4. Permitted and Prohibited Use
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
            You may use our site and tools only for lawful purposes. You agree not to:
          </Typography>
          <Box component="ul" sx={{ pl: 3, color: 'text.secondary', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <li>Systematically scrape technical articles or blog files to train AI databases or create copycat platforms.</li>
            <li>Attempt to bypass security features, reverse engineer client-side tool scripts, or upload malicious code.</li>
            <li>Use automated scrapers, bots, or script commands to exhaust our hosting resources or APIs.</li>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            5. Disclaimer of Warranties & Limitations
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
            CoreTechTalks makes no warranties or representations about the accuracy or completeness of the technical information, guide instructions, or software tools outputs on this site.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            In no event shall CoreTechTalks, its contributors, or its representatives be liable for any direct, indirect, incidental, or consequential damages resulting from your use of the technical articles or tools.
          </Typography>
        </Box>

        <Divider />

        <Box>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 2, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
            6. Contact & Governing Law
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, mb: 2 }}>
            These Terms & Conditions are governed by and construed in accordance with applicable copyright laws.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            For questions or feedback regarding these terms, please contact us at <strong>contact@coretechtalks.com</strong>.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
